module.exports = __webpack_public_path__ + "../resources/img/ic_incomplete_number_2.6f5c4b3b.svg";